import { LectureParams } from '../types/LectureParams'

/**
 * Wraps route params in the legacy `{ match: { params } }` shape that the
 * lecture/quiz Redux selectors still expect, while also exposing them flat.
 *
 * This is the adapter used at `usePropsSelector` / `useLazySelector` call-sites
 * during the react-router → TanStack Router migration (MP-15450): components
 * now read params via TanStack Router's `useParams` and pass the result through
 * here. Spreading keeps it lossless (carries `suffix`, `id`, `channel`, … too).
 */
export default function toMatchParams(params: LectureParams) {
  // Returns `any` to preserve the ergonomics of the former `useMatchParams()`
  // hook (which returned `as any`); the lecture/quiz code and `passProps`-based
  // selectors that consume this were written against that untyped shape.
  return {
    match: { params: { ...params } },
    ...params,
  } as any
}
